// 出力ファイル名の先頭につける種別プレフィックス (GPV-1.0 の命名に準拠:
// 例 MSMR_… / MSMR-WsrfN_… = 主画像種別 + 風レイヤON時は -W{種類})。
// 重い依存を持たないよう DOM から直接読む (NOWC は使わず自前の種別を渡す)。
export function outputFilePrefix(): string {
    const element =
        document.querySelector<HTMLSelectElement>("#EL")?.value || "GPV";
    const windOn = document
        .querySelector("#btn_wind_on")
        ?.classList.contains("btn_onA");
    const windVersion =
        document.querySelector<HTMLSelectElement>("#select_Wver")?.value;
    return windOn && windVersion ? `${element}-W${windVersion}` : element;
}
